export const CONTRIBUTERS_PAGE = "/contributers"
export const SUCCESS_STORIES_PAGE = '/success'
export const NAVBAR = '/nav'
export const EBOOK = '/ebook'